var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHotelIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21h20m-1 0V4a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v17m3-14h6m-6 3h6m-6 3h6M3 21V8a1 1 0 0 1 1-1h5m8 14v-4m-4 0v4m5-4h-6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHotelIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HotelIcon.3863e81a.svg";
export { ForwardRef as ReactComponent };